export const parseImageSrcFromString = (str: string): string | null => {
  const regex = /<img.+src\=(?:\"|\')(.+?)(?:\"|\')(?:.+?)\>/g;
  const match = regex.exec(str);
  return match ? match[1] : null;
};
